import { AbstractControl, FormGroup } from "@angular/forms";
import { PixKeyType } from "../enums/PixKeyType";

const phoneMask = ["(", /[1-9]/, /\d/, ")", /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/,];
const cpfMask = [/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/];
const cnpjMask = [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
const randomized = [
    /[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,'-',
    /[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/, '-',
    /[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/, '-',
    /[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/, '-',
    /[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/,/[a-z0-9]/
];

export class PixValidation {
    onPixTypeChange(typePix: Number, field: AbstractControl): void {
        let control = field;
        control.reset();
        typePix == 0 ? control.disable() : control.enable();
    }

    verifyMaskPixKey(typepix: Number, cnpj?: boolean) {

        if (typepix == PixKeyType.phone) {
            return { mask: phoneMask, guide: false }
        }
        else if (typepix == PixKeyType.cpf_cnpj && !cnpj) {
            return { mask: cpfMask, guide: false}
        }
        else if (typepix == PixKeyType.cpf_cnpj && cnpj) {
            return { mask: cnpjMask, guide: false }
        }
        else if (typepix == PixKeyType.randomized){
            return { mask: randomized, guide: false }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/PixValidation.ts